import evokeTheme from "evokeTheme";
import {
  SVG_NAMESPACE,
  TAB_LOADER_LAYOUT,
  TAB_LOADER_SPINNER,
} from "static/tab_loader";

const {
  SIZE_PX,
  CIRCLE_BOX,
  CIRCLE_THICKNESS,
  CIRCLE_DASH_ARRAY,
  WRAPPER_TURN_MS,
  CIRCLE_TURN_MS,
} = TAB_LOADER_SPINNER;

const SPINNER_COLOR = evokeTheme().palette.secondary.main;

const spin = (element, duration) => {
  if (element.animate) {
    element.animate(
      [{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }],
      { duration, iterations: Infinity }
    );
  }
};

const createSpinner = (doc) => {
  const size = `${SIZE_PX}px`;

  const wrapper = doc.createElement("div");
  wrapper.style.cssText = `display:inline-block;width:${size};height:${size};`;
  spin(wrapper, WRAPPER_TURN_MS);

  const progress = doc.createElement("span");
  progress.setAttribute("role", "progressbar");
  progress.style.cssText =
    `display:inline-block;width:${size};height:${size};` +
    `color:${SPINNER_COLOR};`;
  spin(progress, CIRCLE_TURN_MS);

  const half = CIRCLE_BOX / 2;
  const svg = doc.createElementNS(SVG_NAMESPACE, "svg");
  svg.setAttribute("viewBox", `${half} ${half} ${CIRCLE_BOX} ${CIRCLE_BOX}`);
  svg.style.cssText = "display:block;";

  const circle = doc.createElementNS(SVG_NAMESPACE, "circle");
  circle.setAttribute("cx", String(CIRCLE_BOX));
  circle.setAttribute("cy", String(CIRCLE_BOX));
  circle.setAttribute("r", String((CIRCLE_BOX - CIRCLE_THICKNESS) / 2));
  circle.setAttribute("fill", "none");
  circle.setAttribute("stroke-width", String(CIRCLE_THICKNESS));
  circle.style.cssText = `stroke:currentColor;stroke-dasharray:${CIRCLE_DASH_ARRAY};stroke-dashoffset:0;`;

  svg.appendChild(circle);
  progress.appendChild(svg);
  wrapper.appendChild(progress);
  return wrapper;
};

/**
 * Shows the portal's spinner with a message, centered, in a tab opened with
 * `window.open`. It stays until the tab navigates away. Built with DOM style properties
 * and the Web Animations API so it does not depend on stylesheets or CSP in the blank tab.
 */
export const showLoadingInTab = (tab, message) => {
  const doc = tab.document;
  const { GAP_PX, BACKGROUND_COLOR, TEXT_COLOR, FONT } = TAB_LOADER_LAYOUT;

  const container = doc.createElement("div");
  container.setAttribute("role", "status");
  container.style.cssText =
    "position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;" +
    `justify-content:center;gap:${GAP_PX}px;background:${BACKGROUND_COLOR};` +
    `color:${TEXT_COLOR};font:${FONT};`;

  const text = doc.createElement("div");
  text.textContent = message;

  container.append(createSpinner(doc), text);
  doc.body.style.margin = "0";
  doc.body.appendChild(container);
};
